import { useEffect } from 'react';

// Hook is necessary because errors should be fired outside of renders
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
export const useEffectFireErrorCallback = (error?: boolean, callback: () => void): void => {
	// eslint-disable-next-line react-you-might-not-need-an-effect/no-manage-parent
	useEffect(() => {
		if (error === true) {
			callback();
		}
	}, [callback, error]);
};
